import React from "react";

import { ParallaxBanner } from "react-scroll-parallax";
import Button from "@material/react-button";
import MaterialIcon from "@material/react-material-icon";
import CV from "../CV";
import Github from "react-ionicons/lib/LogoGithub";
import LinkedIn from "react-ionicons/lib/LogoLinkedin";
import { Slide } from "react-reveal";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import ScrollDown from "./ScrollDown";

class Landing extends React.Component {
  static propTypes = {
    history: PropTypes.object
  };

  _greetings = () => {
    const hour = new Date().getHours();
    let greetings;

    if (hour < 8) {
      greetings = "Hi, it's getting late";
    } else if (hour < 12) {
      greetings = "Good morning";
    } else if (hour < 18) {
      greetings = "Good afternoon";
    } else {
      greetings = "Good evening";
    }

    return <p className="h1 marble-white-text">{greetings}</p>;
  };

  render() {
    const { history } = this.props;

    return (
      <Slide bottom>
        <ParallaxBanner
          className="about"
          offsetYMax={20}
          offsetYMin={-5}
          tag="section"
          layers={[
            {
              amount: 0.5,
              image: require("../../assets/images/baier_34_trou_noir.jpg")
            }
          ]}
        >
          <Slide bottom>
            <div className="about-up">
              {this._greetings()}
              <img
                src={require("../../assets/images/roman-pro.jpg")}
                className="face rounded-circle"
                alt=""
              />
              <h2 className="marble-white-text">I'm Roman</h2>
              <h5 className="marble-white-text mb-0">junior data scientist</h5>
            </div>
          </Slide>
          <Slide bottom>
            <div className="about-down">
              <Button
                className="contact"
                raised
                onClick={() => history.push("/contact")}
                icon={<MaterialIcon icon="mail" />}
              >
                Contact me
              </Button>

              <Button
                className="cv"
                raised
                href={require(`../../assets/cv/${process.env.REACT_APP_RESUME_PATH}`)}
                target="_blank"
                rel="noopener noreferrer"
                icon={<CV />}
              >
                My resume
              </Button>

              <Button
                className="github"
                raised
                href="https://github.com/Moccko/"
                target="_blank"
                icon={<Github />}
              >
                GitHub
              </Button>

              <Button
                className="linkedin"
                raised
                href="https://www.linkedin.com/in/roman-rieunier/"
                target="_blank"
                icon={<LinkedIn />}
              >
                LinkedIn
              </Button>
            </div>
          </Slide>
          <ScrollDown anchor="projects" />
        </ParallaxBanner>
      </Slide>
    );
  }
}

export default withRouter(Landing);
